import brandColors from "style/color/brandColor";

const myrealtrip = {
  fonts: {
    main: "애플 SD 산돌고딕 Neo, Apple SD Gothic Neo, NanumSquare, sans-serif",
    number: "Rubik"
  },
  weight: {
    light: 300,
    normal: 400,
    bold: 600,
    bolder: 700,
    extraBold: 800
  },
  radius: "5px",
  colors: {
    primary: brandColors.primary,
    secondary: brandColors.secondary,
    white: brandColors.white,
    text: brandColors.gray1,
    text2: brandColors.gray2,
    textSub: brandColors.gray3,
    textType: brandColors.gray2,
    inputBorder: brandColors.gray4,
    divider: brandColors.gray1,
    divider2: brandColors.gray5,
    divider3: brandColors.gray2,
    planText: brandColors.gray2,
    productInfo: brandColors.gray7,
    footerDivider: brandColors.gray3,
    bg: brandColors.gray13,
    bg2: brandColors.gray9
  },
  buttonPrimary: {
    colorBg: brandColors.primary,
    colorFont: brandColors.white,
    sizeFont: "18px"
  },
  buttonSmall: {
    colorFont: brandColors.gray2,
    colorBorder: brandColors.gray4,
    sizeFont: "12px"
  },
  buttonText: {
    colorFont: brandColors.gray2,
    sizeFont: "12px"
  },
  popup: {
    sizeButton: "16px",
    sizeHeader: "22px",
    colorFont: brandColors.gray2
  },
  popupBottom: {
    sizeHeader: "16px",
    colorFont: brandColors.gray6
  },
  label: {
    colorFont: brandColors.gray1,
    sizeFont: "12px"
  },
  placeholder: {
    colorFont: brandColors.gray3,
    sizeFont: "12px"
  },
  input: {
    colorBorder: brandColors.gray4,
    colorFont: brandColors.gray1,
    sizeFont: "14px"
  },
  selectBox: {
    colorBorder: brandColors.gray4,
    colorFont: brandColors.gray1
  },
  title: {
    sizeFont: "22px"
  },
  text: {
    colorFont: brandColors.gray3,
    colorDisabled: brandColors.gray4,
    sizeFontM: "14px",
    sizeFont: "12px",
    sizeFontXS: "11px"
  },
  calendar: {
    font: "14px",
    headerFont: "18px",
    disabledColor: brandColors.gray6,
    headerColor: brandColors.gray2
  },
  loading: {
    sizeFont: "18px",
    colorFont: brandColors.gray2
  },
  history: {
    sizeFont: "16px"
  }
};

export default myrealtrip;
